module.exports = __webpack_public_path__ + "media/images/ico-mic-6bf26ba4.svg";